import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableFreightSupport = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableFreightSupport);
};
